import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { setPermanentSession } from "modules/Login/hooks";
import { ApiInstance } from "utils/Api";

import type { DefaultError } from "@tanstack/react-query";
import type { Session } from "modules/Login/queryKeys";

type CredentialsLoginPayload = {
  username: string;
  password: string;
};

export const useCredentialsLoginMutation = (onLoginError: (error: DefaultError) => void) =>
  useTypedMutation<CredentialsLoginPayload, Session>({
    mutationFn: async payload => (await ApiInstance.post("/session/login/credentials", payload, ENV.authBaseURL)).data,
    onSuccess: (_, session) => setPermanentSession(session),
    onError: onLoginError
  });
